import { useEffect } from "react";
import { useFormContext, UseFormTrigger, useWatch } from "react-hook-form";

import { NumberInput } from "@dzambalaorg/mui-inputs-core";

export interface IMinInputProps {
  name?: string;
}

const changeMinByMaxAndTriggerMin = (
  maxValue: number,
  trigger?: UseFormTrigger<{ min: number; [key: string]: any }>,
) => {
  /** set min value 1 if max value less than 3 **/
  if (maxValue < 3) {
    if (trigger) {
      void trigger("min");
    }
    return 1;
  }
  return maxValue - 1;
};

export const MinInput = (props: IMinInputProps) => {
  const { name = "min" } = props;

  const minValue: number = useWatch({ name });
  const maxValue: number = useWatch({ name: "max" });

  const form = useFormContext<any>();

  useEffect(() => {
    // maxValue can be ""
    if (typeof maxValue !== "string" && minValue >= maxValue) {
      form.setValue(name, changeMinByMaxAndTriggerMin(maxValue, form.trigger));
    }
  }, [maxValue]);

  return (
    <NumberInput
      required
      name={name}
      inputProps={{
        min: 1,
        max: changeMinByMaxAndTriggerMin(maxValue),
      }}
    />
  );
};
